const ferries = {
  ferry: "เรือข้ามฟาก", // translated
  ferries: "เรือเฟอร์รี่", // translated
  selectOriginPort: "เลือกพอร์ตต้นทาง", // translated
  selectDestPort: "เลือกพอร์ตปลายทาง", // translated
  continue: "ดำเนินการต่อ", // translated
  viewTimetables: "ดูตารางเวลา", // translated
  operator: "ผู้ดำเนินการ", // translated
  cabin: "ห้องโดยสาร", // translated
  cabins: "เคบิน", // translated
  place: "สถานที่", // translated
  places: "สถานที่", // translated
  seat: "ที่นั่ง", // translated
  seats: "ที่นั่ง", // translated
  seating: "ที่นั่ง", // translated
  deckSpace: "พื้นที่ดาดฟ้า", // translated
  compulsory: "ภาคบังคับ", // translated
  departure: "การออกเดินทาง", // translated
  total: "ทั้งหมด", // translated
  back: "กลับ", // translated
  next: "ต่อไป", // translated
  duration: "ระยะเวลา", // translated
  return: "กลับ", // translated
  prebook: "จองล่วงหน้า", // translated
  travelInfo: "ข้อมูลการเดินทาง", // translated
  book: "หนังสือ", // translated
  adults: "ผู้ใหญ่", // translated
  child: "เด็ก", // translated
  seniors: "ผู้สูงอายุ", // translated
  senior: "อาวุโส", // translated
  to: "ถึง", // translated
  passenger: "ผู้โดยสาร", // translated
  details: "รายละเอียด", // translated
  currencyForTickets: "สกุลเงินสำหรับตั๋วเหล่านี้จะเป็น", // translated
  seatsError: "จำนวนผู้โดยสารไม่เท่ากับความจุ", // translated
  title: "ชื่อ", // translated
  firstName: "ชื่อจริง", // translated
  lastName: "นามสกุล", // translated
  email: "อีเมล", // translated
  phone: "โทรศัพท์", // translated
  dateOfBirth: "วันเกิด", // translated
  placeOfBirth: "สถานที่เกิด", // translated
  groupLeader: "หัวหน้ากลุ่ม", // translated
  isRequired: "ต้องระบุ", // translated
  charactersOnly: "ตัวละครเท่านั้น", // translated
  latinCharactersAndSpacesOnly: "อักขระละตินและช่องว่างเท่านั้น", // translated
  validEmail: "ไม่ใช่อีเมลที่ถูกต้อง", // translated
  atLeastOneAdult: "ต้องมีผู้ใหญ่อย่างน้อย 1 คน", // translated
  atLeastOneSenior: "ต้องมีผู้อาวุโสอย่างน้อย 1 คน", // translated
  toastAlert: "โปรดแก้ไขข้อผิดพลาดทั้งหมดในแบบฟอร์มด้านล่าง", // translated
  backToFerriesList: "กลับไปที่รายการเรือเฟอร์รี่", // translated
  bestPrice: "ราคาดีที่สุด", // translated
  fastest: "เร็วที่สุด", // translated
  beforeDeparture: "ก่อนออกเดินทาง", // translated
  perPerson: "ต่อคน", // translated
  notAvailableForOnlineBooking: "ไม่สามารถจองออนไลน์ได้", // translated
  hurryLimitedAvailability: "รีบหน่อย! มีจำนวนจำกัด", // translated
  berth: "ท่าเทียบเรือ", // translated
  berths: "ท่าเทียบเรือ", // translated
  sumOfSelectionNotEqualToPersons: "ผลรวมที่คุณเลือกไม่เท่ากับจำนวนผู้โดยสาร", // translated
  attemptToBook: "คุณได้พยายามจองยอดรวมของ", // translated
  seatsWhenYouHave: "ที่นั่งเมื่อคุณมี", // translated
  passengersTravelling: "ผู้โดยสารที่เดินทาง", // translated
  withReturn: "พร้อมตั๋วไปกลับ", // translated
  pleaseCorrectYourSelection: "โปรดแก้ไขการเลือกของคุณ", // translated
  pleaseSelectUpTo: "กรุณาเลือกถึง", // translated
  accommodationTypes: "ประเภทที่พัก", // translated
  selectionPrices: "ราคาคัดเลือก", // translated
  yourCurrentTicket: "ประเภทตั๋วปัจจุบันของคุณคือ", // translated
  upgradeTo: "อัพเกรดเป็น", // translated
  wouldYouLikeToUpgrade: "คุณต้องการอัพเกรดประเภทตั๋วของคุณหรือไม่?", // translated
  backToTicketTypes: "กลับไปที่ประเภทตั๋ว", // translated
  originPort: "พอร์ตต้นทาง", // translated
  destinationPort: "พอร์ตปลายทาง", // translated
  outboundDate: "วันที่ขาออก", // translated
  inboundDate: "วันที่ขาเข้า", // translated
  passengers: "ผู้โดยสาร", // translated
  hasReturn: "มีรีเทิร์น", // translated
  passportNumber: "หมายเลขหนังสือเดินทาง", // translated
  passportExpiryDate: "หนังสือเดินทางวันหมดอายุ", // translated
  passportPlaceOfIssue: "หนังสือเดินทาง สถานที่ออก", // translated
  passportStartDate: "วันที่เริ่มทำหนังสือเดินทาง", // translated
  cityCode: "รหัสเมือง", // translated
};

export default ferries;
